import Filters from "./components/Filters";
import Preview from "./components/Preview";
import BatchAutoSweepContextProvider from "./contexts";

function BatchContractSweep() {
  return (
    <BatchAutoSweepContextProvider>
      <Filters />
      <br />
      <Preview />
    </BatchAutoSweepContextProvider>
  );
}

export default BatchContractSweep;
